import {
  Button,
  Text,
  Loader,
  Stack,
  Center,
  Box,
  Textarea,
  Group,
} from "@mantine/core";
import { useAppDispatch, useAppSelector } from "../hooks";
import { RootState } from "../store";
import {
  displayErrorMessage,
  displayInfoMessage,
  displayServerErrorMessage,
} from "../shared/ErrorMessage";
import { initialize, updateField } from "../slices/form/sendHostMessage";
import { useEffect } from "react";
import { Logo } from "../shared/components/Logo";
import {
  SendHostMessageRequest,
  useSendHostMessageMutation,
} from "../slices/api/guestsApi";

interface Props {
  ventId: string;
  onClose: () => void;
}
const SendHostMessage = (props: Props) => {
  const { data } = useAppSelector(
    (state: RootState) => state.sendHostMessageForm
  );

  const dispatch = useAppDispatch();
  useEffect(() => {
    dispatch(
      initialize({
        message: "",
      })
    );
  }, []);

  const [sendHostMessage, { isLoading: isSending }] =
    useSendHostMessageMutation();

  const handleSendHostMessage = async () => {
    const request: SendHostMessageRequest = {
      ventId: props.ventId,
      message: data?.message ?? "",
    };
    if (data == null) {
      displayErrorMessage("data should not be null");
      return;
    }

    try {
      await sendHostMessage(request).unwrap();
      displayInfoMessage("Your message was sent to the host.");
      props.onClose();
    } catch (error) {
      displayServerErrorMessage(error);
      return;
    }
  };

  if (!data) {
    return <Loader color="blue" />;
  }

  return (
    <Center>
      <form>
        <Stack align="center" justify="center" gap="sm">
          <Box w={100}>
            <Logo />
          </Box>
          <Text size="lg">Send message to host</Text>
          <Textarea
            mt="md"
            style={{ width: "350px" }}
            maxLength={1000}
            label="Message to Host"
            value={data.message ?? ""}
            onChange={(event) =>
              dispatch(
                updateField({
                  field: "message",
                  value: event.currentTarget.value,
                })
              )
            }
          />

          <Group>
            <Button mt="md" mr="md" onClick={props.onClose}>
              Cancel
            </Button>
            <Button
              mt="md"
              onClick={() => handleSendHostMessage()}
              disabled={isSending || data.message === ""}
              rightSection={isSending ? <Loader size={14} /> : null}
            >
              Send
            </Button>
          </Group>
        </Stack>
      </form>
    </Center>
  );
};

export default SendHostMessage;
